import { render, staticRenderFns } from "./importAdmissionList.vue?vue&type=template&id=1e97977c"
import script from "./importAdmissionList.vue?vue&type=script&lang=js"
export * from "./importAdmissionList.vue?vue&type=script&lang=js"
import style0 from "./importAdmissionList.vue?vue&type=style&index=0&id=1e97977c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports